import { ADMIN_TYPES } from "services/types";
import { init, success, finish, error } from "services/common";
import { RotoCompanyService } from "./api";
import { actionForAddCircularPlanningCompanyFromList } from "services/redux/Reference/DynamicCircularTemplate/action";

const rotoCompanyService = new RotoCompanyService();

// Fetch paginated Roto company list
export const getRotoCompanyPaginationListNew = (q, loadMore = false) => {
  return async (dispatch) => {
    dispatch(init(ADMIN_TYPES.ROTO_COMPANY_LISTING));

    try {
      const response = await rotoCompanyService.getRotoCompanyPaginationListNew(
        q
      );

      if (response?.cancelApi === false) return;

      if (response.isSuccess) {
        dispatch(
          success(
            loadMore
              ? ADMIN_TYPES.ROTO_COMPANY_LISTING_LOAD_MORE
              : ADMIN_TYPES.ROTO_COMPANY_LISTING,
            response.data
          )
        );
      } else {
        throw new Error(
          response.errorMessage || "Failed to fetch company list"
        );
      }
    } catch (err) {
      dispatch(error(ADMIN_TYPES.ROTO_COMPANY_LISTING, err.message));
    } finally {
      dispatch(finish(ADMIN_TYPES.ROTO_COMPANY_LISTING));
    }
  };
};

// Add company to dynamic template
export const addCompanyToDynamicTemplate = (formData) => {
  return async (dispatch) => {
    dispatch(init(ADMIN_TYPES.ADD_COMPANY_TO_TEMPLATE));

    try {
      const response = await dispatch(
        actionForAddCircularPlanningCompanyFromList(formData)
      );

      if (response?.payload?.isSuccess) {
        dispatch(
          success(ADMIN_TYPES.ADD_COMPANY_TO_TEMPLATE, {
            companyId: formData.companyId,
            templateId: formData.circularPlanningTemplateId,
          })
        );
        return { isSuccess: true };
      } else {
        throw new Error(
          response?.payload?.errorMessage || "Failed to add company to template"
        );
      }
    } catch (err) {
      dispatch(error(ADMIN_TYPES.ADD_COMPANY_TO_TEMPLATE, err.message));
      return { isSuccess: false, errorMessage: err.message };
    } finally {
      dispatch(finish(ADMIN_TYPES.ADD_COMPANY_TO_TEMPLATE));
    }
  };
};

// Ensure the following ADMIN_TYPES are defined in "services/types":
/*
  ROTO_COMPANY_LISTING: 'ROTO_COMPANY_LISTING',
  ROTO_COMPANY_LISTING_LOAD_MORE: 'ROTO_COMPANY_LISTING_LOAD_MORE',
  ADD_COMPANY_TO_TEMPLATE: 'ADD_COMPANY_TO_TEMPLATE',
  ADD_COMPANY_TO_TEMPLATE_SUCCESS: 'ADD_COMPANY_TO_TEMPLATE_SUCCESS',
  ADD_COMPANY_TO_TEMPLATE_FAILURE: 'ADD_COMPANY_TO_TEMPLATE_FAILURE'
*/
